/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: chart-pill-component
 *
 * Created by rwilliams on 2/23/17.
 */
'use strict';
function ChartPillController () {
	var self = this;

	var currentValue = 0;
	var defaultStatusWidth = 8; // In percent

	self.getPillWidth = function (value) {
		if (self.chartdata.showFinished && value > 0) {
			var remainingTotal;
			var percentTotal = (value/self.chartdata.total)*100;

			percentTotal = Math.round(percentTotal);

			if (percentTotal < 10) {
				currentValue += defaultStatusWidth;
				return defaultStatusWidth;
			}

			if ((percentTotal + currentValue) >= 100) {
				if (percentTotal + currentValue === 100) {
					currentValue = 0;
					return percentTotal;
				} else {
					remainingTotal = 100 - currentValue;
					currentValue = 0;
					return remainingTotal;
				}
			}

			currentValue += percentTotal;

			return percentTotal;
		} else {
			var total = 0;

			for (var i=0; i<self.chartdata.data.length; i++) {
				total = total + self.chartdata.data[i].value;
			}
			return value/total*100;
		}
	};
}

angular.module('prism-ui.components').component('chartPill', {
	templateUrl: 'components/visual/chartPill/chart-pill-template.html',
	controller: ChartPillController,
	bindings: {
		chartdata: '<',
		statusChange: '&'
	}
});
